const CALL_ME_BACK_TRIGGER = 'CALL_ME_BACK_TRIGGER';
export function callMeBackTrigger({ isVisible, submitStartTrackName = '', submitSuccessTrackName = '' }  = {}) {
    return { type: CALL_ME_BACK_TRIGGER, isVisible, submitSuccessTrackName, submitStartTrackName }
}

export const callMeBackReducer = (state = { isVisible: false, submitSuccessTrackName: '', submitStartTrackName: '' }, action) => {
    switch (action.type) {
        case CALL_ME_BACK_TRIGGER: {
            return { 
                ...state, isVisible: action.isVisible || !state.isVisible, 
                submitStartTrackName: action.submitStartTrackName,
                submitSuccessTrackName: action.submitSuccessTrackName,
            }
        }
        default: {
            return state;
        }
    }
}